import { FC } from 'react'
import { KTCard } from '../../../_metronic/helpers'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { PageOverlayer } from '../../../components/PageOverlayer'
import { Header } from './components/header/Header'
import { FilterProvider } from './core/FilterProvider'
import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponseLoading } from './core/QueryResponseProvider'
import { Table } from './table/Table'
import { Totalizer } from './Totalizer'
import { ReportBonusSaleConfig } from './ReportBonusSaleConfig'
import { ReportConfigProvider } from './ConfigContext'

type Props = {
  config: ReportBonusSaleConfig
}

const BonusSaleReportPageInner = () => {
  const { itemIdForUpdate } = useListView()
  const isLoading = useQueryResponseLoading()

  return (
    <>
      <FilterProvider>
        {isLoading && <PageOverlayer />}
        <KTCard>
          <Header />
          <Totalizer />
          <Table />
        </KTCard>
        {itemIdForUpdate !== undefined}
      </FilterProvider>
    </>
  )
}

const BonusSaleReportPage: FC<Props> = ({ config }) => {
  const groupBreadcrumbs: Array<PageLink> = [
    {
      title: config.pageTitle,
      path: config.breadcrumbPath,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <ReportConfigProvider config={config}>
      <PageTitle breadcrumbs={groupBreadcrumbs}>{config.pageTitle}</PageTitle>
      <QueryRequestProvider>
        <QueryResponseProvider>
          <ListViewProvider>
            <BonusSaleReportPageInner />
          </ListViewProvider>
        </QueryResponseProvider>
      </QueryRequestProvider>
    </ReportConfigProvider>
  )
}

export default BonusSaleReportPage
